import React from 'react'
import FatalErrorPage from 'src/pages/FatalErrorPage/FatalErrorPage'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return <FatalErrorPage />
    }

    return this.props.children
  }
}

export default ErrorBoundary

